import { Component, inject, OnInit } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { NgxUiLoaderModule } from 'ngx-ui-loader';
import { CommonModule } from '@angular/common';
import 'zone.js';
import { ServiceWorkerRegister } from './core/service-worker/serviceWorker';

@Component({
  selector: 'tusangaire-root',
  standalone: true,
  imports: [
    RouterOutlet,
    CommonModule,
    TranslateModule,
    NgxUiLoaderModule,
    HttpClientModule
  ],
  providers: [TranslateService],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {
  title = 'af-notification';
  message:any = null;
  serviceWorker: any;
  constructor(
    public translate: TranslateService,
    private router: Router
  ) {
    translate.addLangs(['en', 'ar']);
    translate.setDefaultLang('en');
    this.serviceWorker = inject(ServiceWorkerRegister);
    this.serviceWorker.publicApi();
  }
  ngOnInit(): void {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        document.body.scrollTop = 0;
        setTimeout(() => {
          window.scrollTo(0, 0);
        }, 0);
      }
    });
    // this.requestPermission();
    // this.listen();
  }


  // requestPermission() :void {
  //   const messaging = getMessaging();
  //   getToken(messaging,
  //     { vapidKey: environment.firebase.vapidKey}).then(
  //     (currentToken) => {
  //       if (currentToken) {
  //         console.log('Hurraaa!!! we got the token.....');
  //       } else {
  //         console.log('No registration token available. Request permission to generate one.');
  //       }
  //     }).catch((err) => {
  //     console.log('An error occurred while retrieving token. ', err);
  //   });
  // }
  // listen() :void {
  //   const messaging = getMessaging();
  //   onMessage(messaging, (payload) => {
  //     console.log('Message received. ', payload);
  //     this.message = payload;
  //   });
  // }
}
